import {
	GET_RECEIPTS_REFERENCES_LIST,
	FAIL_GET_RECEIPTS_REFERENCES_LIST,
	SUCCESS_GET_RECEIPTS_REFERENCES_LIST,
	RESET_PROCESS_ERROR,
	GET_JIGYOSHA_LIST,
	FAIL_GET_JIGYOSHA_LIST,
	SUCCESS_GET_JIGYOSHA_LIST,
	SET_RECEIPTS_REFERENCES_LIST,
	FAIL_SET_RECEIPTS_REFERENCES_LIST,
	SUCCESS_SET_RECEIPTS_REFERENCES_LIST,
	RESET_MASTER_RECEIPTS_REFERENCES,
	FETCH_CSV_MASTER_RECEIPTS_REFERENCES,
	FAIL_FETCH_CSV_MASTER_RECEIPTS_REFERENCES,
	SET_CSV_MASTER_RECEIPTS_REFERENCES,
	GET_KEIYAKU_KIGYOU_LIST,
	FAIL_GET_KEIYAKU_KIGYOU_LIST,
	SUCCESS_GET_KEIYAKU_KIGYOU_LIST,
} from '../../actions';
import {downloadCsvData} from '../../common/utils/download-csv';
import moment from 'moment';


const initialState = {
	data:[],
	jigyoshaData:[],
	keiyakukigyouData:[],
	isFetching: false,
	error: undefined,
	isProcessError : false,
};
export default function masterReceiptsReferencesSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});
    switch (action.type) {
		case GET_RECEIPTS_REFERENCES_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_RECEIPTS_REFERENCES_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_RECEIPTS_REFERENCES_LIST:
			ret.data = action.payload.data;
			ret.isFetching = false;
			return ret;
		case GET_JIGYOSHA_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_JIGYOSHA_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_JIGYOSHA_LIST:
			ret.jigyoshaData = action.payload.data;
			ret.isFetching = false;
			return ret;
		case GET_KEIYAKU_KIGYOU_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_GET_KEIYAKU_KIGYOU_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_GET_KEIYAKU_KIGYOU_LIST:
			ret.keiyakukigyouData = action.payload.data.map(suggestion => ({
				value: suggestion.KeiyakuKigyouCD,
				label: suggestion.KeiyakuKigyouCD + ' : ' + suggestion.KeiyakuKigyouName,
				name : suggestion.KeiyakuKigyouName
			}));
			ret.isFetching = false;
			return ret;
		case SET_RECEIPTS_REFERENCES_LIST:
			ret.isFetching = true;
			return ret;
		case FAIL_SET_RECEIPTS_REFERENCES_LIST:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SUCCESS_SET_RECEIPTS_REFERENCES_LIST:
			ret.data = action.payload.data;
			ret.isFetching = false;
			return ret;
		case FETCH_CSV_MASTER_RECEIPTS_REFERENCES:
			ret.isFetching = true;
			return ret;
		case FAIL_FETCH_CSV_MASTER_RECEIPTS_REFERENCES:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SET_CSV_MASTER_RECEIPTS_REFERENCES:
			const csvData = action.payload.data;
			const columns = action.payload.columns;
			const now = moment().format('YYYYMMDDhhmmss');
			downloadCsvData("電子受領照会マスタ"+now, columns,csvData);
			ret.isFetching = false;
			return ret;
		case RESET_MASTER_RECEIPTS_REFERENCES:
			ret.data=[];
			ret.jigyoshaData=[];
			ret.JigyoushaCD=null;
			return ret;
		case RESET_PROCESS_ERROR:
			ret.isProcessError = false;
			return ret;
		default:
			return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/master/receipts-references.js